import { createEntityCachedQueryHook, EntityCachedQueryHook } from '@/lib/react-hooks/entity-cached-query-hook'
import { loadData } from '@/lib/requests/loadData'

import { Airport } from './index'

export async function searchAirports(search: string) {
	const lowerSearch = search.toLocaleLowerCase().trim()
	if (!lowerSearch) {
		return []
	}

	try {
		const { data } = await loadData<Airport[]>({ resourcePath: 'sites', params: { search: lowerSearch } })
		return data
	} catch (e) {
		console.error(e)
		return []
	}
}

async function queryAirport(code: string) {
	const { data: airports } = await loadData<Airport[]>({ resourcePath: 'airports', params: { search: code } })

	const airport = airports.find((airport) => airport.code === code)
	if (!airport) {
		throw new Error('Not found')
	}

	return airport
}

export const useAirportCachedQuery = createEntityCachedQueryHook(
	'code',
	(code: string) => ['airports', code],
	queryAirport,
	async (_, query: string) => {
		const { data: locations } = await loadData<Airport[]>({ resourcePath: 'airports', params: { search: query } })
		const airports = locations.filter((location) => location.location_type === 'airport')
		return airports
	},
	({ getEntity, queryEntity, searchEntities }: EntityCachedQueryHook<string, Airport>) => ({
		getAirportByCode: (
			code?: string,
			placeholder: (code: string) => Partial<Airport> = (code) => ({
				code,
				name: code,
			}),
		) => getEntity(code, placeholder),
		queryAirport: queryEntity,
		queryAirports: searchEntities,
	}),
)
